/** Minimal international syntax check, matching the API. Does not prove ownership. */
export function normalizeInternationalPhone(input: string): string {
  if (input.length > 40 || !/^[+0-9 ().-]+$/.test(input)) {
    throw new Error('Enter an international number with + and country code, without extensions.');
  }
  const phone = input.replace(/[ ().-]/g, '');
  if (!/^\+[1-9][0-9]{6,14}$/.test(phone)) {
    throw new Error('Enter + followed by 7–15 digits, including your country code.');
  }
  return phone;
}
